import React from "react";
import { TextField } from "@mui/material";

const CustomInput = ({
  label,
  name,
  value,
  onChange,
  placeholder = "",
  placeholderFontSize = "0.75rem",
  type = "text",
  required = false,
  fullWidth = true,
  size = "small",
  disabled = false,
  error = false,
  helperText = "",
  multiline = false,
  rows = 1,
  InputProps = {},
  ...props
}) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (onChange) {
      onChange({
        target: {
          name: name,
          value: value,
        },
      });
    }
  };

  return (
    <TextField
      fullWidth={fullWidth}
      size={size}
      label={label}
      name={name}
      value={value ?? ""}
      onChange={handleChange}
      placeholder={placeholder}
      type={type}
      required={required}
      disabled={disabled}
      error={error}
      helperText={helperText}
      multiline={multiline}
      rows={rows}
      InputProps={InputProps}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          backgroundColor: disabled ? "#F1F5F9" : "#FFFFFF",
          "&:hover fieldset": {
            borderColor: error ? "#EF4444" : "#3B82F6",
          },
          "& fieldset": {
            borderColor: error ? "#EF4444" : "#E2E8F0",
          },
          "&.Mui-focused fieldset": {
            borderColor: error ? "#EF4444" : "#3B82F6",
            borderWidth: 2,
          },
        },
        "& .MuiInputLabel-root": {
          fontSize: "0.75rem",
          fontWeight: 500,
          color: "#475467",
          "&.Mui-focused": {
            color: error ? "#EF4444" : "#3B82F6",
          },
        },
        "& .MuiInputBase-input::placeholder": {
          fontSize: placeholderFontSize,
          opacity: 1,
          color: "#94a3b8",
        },
        "& .MuiInputBase-input": {
          fontSize: "0.875rem",
        },
        "& .MuiInputBase-root.Mui-disabled .MuiInputBase-input::placeholder": {
          color: "#94a3b8",
        },
      }}
      {...props}
    />
  );
};

export default CustomInput;